import React, { PureComponent } from "react";
import KickImage from 'Reuseables/KickImage';
import { Link } from "react-router-dom";
import { Button, Row, Col } from "reactstrap";
import PropTypes from "prop-types";
import Brands from "./Brands";
import styled from "styled-components";
import { ProtectedButton } from "../../Forms";
import { getRetailPrice } from "../../../utils";
import moment from "moment";

export default class ProductTitle extends PureComponent {
  render() {
    const {
      display_name,
      sku,
      colour,
      type,
      dimension,
      release_date,
      retail_price,
      currency,
      category,
      id,
      selected,
      isLogged,
      userData,
      roleNotAlloweds,
      hide_box_info,
    } = this.props;

    return (
      <div className="product-title-wrapper">
        {/* <Brands brands={this.props.brands}/> */}
        <div className="brand-title-wrapper">
          <p className="brand-title">{this.props.brands[0]}</p>
          <div className="button-wrapper">
            {this.props.productDetail &&
            !this.props.isVintage &&
            ((category === "apparels" &&
              this.props.userData.roles.includes("seller_apparel")) ||
              (category === "sneakers" &&
                this.props.userData.roles.includes("seller")) ||
              (category === "handbags" &&
                this.props.userData.roles.includes("seller_handbag")) ||
              (category === "lifestyles" &&
                this.props.userData.roles.includes("seller_lifestyle"))) ? (
              <ProtectedButton
                isLogged={isLogged}
                userData={userData}
                countryCodeAllowed={[null, "IDN"]}
                className="btn-white flat"
                roleNotAlloweds={roleNotAlloweds}
                buttonText="SELL"
                category={category}
              >
                <Link
                  to={{
                    pathname: `/user_dashboard/sell-request`,
                    id: id,
                    state: display_name,
                    selected: selected,
                    category: category,
                    hide_box_info: hide_box_info,
                  }}
                  className="btn btn-secondary btn-white flat"
                >
                  Sell
                </Link>
              </ProtectedButton>
            ) : null}
            <Button>
              <p>Wishist</p>
            </Button>
          </div>
        </div>
        <div className="sneaker-title-wrapper">
          <p className="sneaker-title">{display_name}</p>
        </div>
        {/* <Row>
          <Col className="sku-wrapper" md={8} sm={8} xs={12}>
            <Row className="row-info">
              <p className="sku-number">SKU</p>
              <p className="sku-number">
                {sku === null || sku === "" ? "-" : sku}
              </p>
            </Row>
            <Row className="row-info">
              <p className="sku-number">Color</p>
              <p className="sku-number">
                {colour === null || colour === "" ? "-" : colour}
              </p>
            </Row>
            <Row className="row-info">
              <p className="sku-number">Material</p>
              <p className="sku-number">
                {type === null || type === "" ? "-" : type}
              </p>
            </Row>
            <Row className="row-info">
              <p className="sku-number">Dimension</p>
              <p className="sku-number">
                {dimension === null || dimension === "" ? "-" : dimension}
              </p>
            </Row>
            <Row className="row-info">
              <p className="sku-number">Release Date</p>
              <p className="sku-number">
                {release_date === null || release_date === ""
                  ? "-"
                  : moment(release_date).format("Do MMMM YYYY")}
              </p>
            </Row>
            <Row className="row-info">
              <p className="sku-number">Retail</p>
              <p className="sku-number">
                {retail_price === null || retail_price === "0.00"
                  ? "-"
                  : getRetailPrice(currency, retail_price)}
              </p>
            </Row>
          </Col>
          {this.props.productDetail &&
          !this.props.isVintage &&
          ((category === "apparels" &&
            this.props.userData.roles.includes("seller_apparel")) ||
            (category === "sneakers" &&
              this.props.userData.roles.includes("seller")) ||
            (category === "handbags" &&
              this.props.userData.roles.includes("seller_handbag")) ||
            (category === "lifestyles" &&
              this.props.userData.roles.includes("seller_lifestyle"))) ? (
            <Col sm={4} xs={12}>
              <div className="button-sell">
                <ProtectedButton
                  isLogged={isLogged}
                  userData={userData}
                  countryCodeAllowed={[null, "IDN"]}
                  className="btn-white flat"
                  roleNotAlloweds={roleNotAlloweds}
                  buttonText="SELL"
                  category={category}
                >
                  <Link
                    to={{
                      pathname: `/user_dashboard/sell-request`,
                      id: id,
                      state: display_name,
                      selected: selected,
                      category: category,
                      hide_box_info: hide_box_info,
                    }}
                    className="btn btn-secondary btn-white flat"
                  >
                    SELL
                  </Link>
                </ProtectedButton>
              </div>
            </Col>
          ) : null}
        </Row> */}
      </div>
    );
  }
}
ProductTitle.propTypes = {
  id: PropTypes.number,
  display_name: PropTypes.string,
  brands: PropTypes.array,
};
ProductTitle.defaultProps = {
  id: null,
  display_name: "",
  brands: [],
};
const Wrapper = styled.div`
  margin-bottom: 50px;
`;
